import { configureStore } from '@reduxjs/toolkit'
import userSlice from './userSlice'
import transactionSlice from './transactionSlice'
import requestSlice from './requestSlice'

const store = configureStore({
  reducer: {
    user: userSlice,
    transaction: transactionSlice,
    request: requestSlice,
  },
})

export default store
